import React from 'react';
import * as S from './style';
import Image from '../../../../../../app/js/components/loggedout/common/Image';
import CgListItem from '../feature-list/list-item';

const Card = ({course, subjectMap}) => {
  const title = course[1];
  const isElaSubject = title === "Reading";
  const bulletColor = isElaSubject ? '#B746E6' : '#4E9DE8';
  return (
    <S.Card>
      <S.SubjectTitle>{title}</S.SubjectTitle>
      <Image src={ subjectMap.image }/>
      <S.CgListWrapper>
        {
          subjectMap[title].map((val)=>
            <CgListItem 
              hideList={true} 
              fColor={'#1a1a1a'} 
              bulletColor={bulletColor} 
              item={val}/>)
        }
      </S.CgListWrapper>
    </S.Card>
  )
}

export default Card;